import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=10addcbd&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10addcbd')) {
      api.createRecord('10addcbd', component.options)
    } else {
      api.reload('10addcbd', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=10addcbd&", function () {
      api.rerender('10addcbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QEot06hkMm3Y/JS/offershelp.vue"
export default component.exports